'use client';

import Container from '@components/ui/container';
import { Element } from 'react-scroll';
import { useTranslation } from '@i18n/client';

function makeTitleToDOMId(title: string) {
  return title.toLowerCase().split(' ').join('_');
}

export default function ImpressumPageContent({ lang }: { lang: string }) {
  const { t } = useTranslation(lang, 'impressum');
  return (
    <div className="py-12 lg:py-16 2xl:py-20 xl:px-16 2xl:px-24 3xl:px-36">
      <Container>
        <div className="flex flex-col md:flex-row">
          <div className="md:ltr:pl-8 md:rtl:pr-8">
            <Element
              name="impressum"
              id={makeTitleToDOMId(t('Impressum'))}
              className="mb-8 lg:mb-12 last:mb-0 order-list-enable"
            >
              {/*<Heading className="mb-4 lg:mb-6 font-body" variant="title">*/}
              {/*    {t("Impressum")}*/}
              {/*</Heading>*/}
              <div className="space-y-5 text-sm leading-7 text-brand-muted lg:text-20px">
                {Array.from(Array(8).keys()).map((i) => (
                  <>
                    <div
                      dangerouslySetInnerHTML={{ __html: t(`para-${i + 1}`) }}
                    />
                  </>
                ))}
              </div>
            </Element>
          </div>
          {/* End of content */}
        </div>
      </Container>
    </div>
  );
}
